import { render, staticRenderFns } from "./OrganizationCreateModal.vue?vue&type=template&id=603fc86e"
import script from "./OrganizationCreateModal.vue?vue&type=script&lang=ts"
export * from "./OrganizationCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports